import { render, staticRenderFns } from "./WallVote.vue?vue&type=template&id=0d04cece&scoped=true&"
import script from "./WallVote.vue?vue&type=script&lang=js&"
export * from "./WallVote.vue?vue&type=script&lang=js&"
import style0 from "./WallVote.vue?vue&type=style&index=0&id=0d04cece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d04cece",
  null
  
)

export default component.exports